export default "__VITE_ASSET__Cvy56DJi__"